import toast from './toast';

function isOffline(): boolean {
  try {
    if (typeof navigator !== 'undefined' && 'onLine' in navigator) {
      return navigator.onLine === false;
    }
  } catch {
    // Em caso de ambiente sem navigator ou erro inesperado, assumir online=false não é apropriado.
    // Mantemos o fallback padrão (false) para não bloquear ações indevidamente.
    return false;
  }
  return false;
}

function isLikelyNetworkError(err: unknown): boolean {
  if (!err) return false;
  const msg = String((err as any)?.message || err || '').toLowerCase();
  return (
    msg.includes('failed to fetch') ||
    msg.includes('networkerror') ||
    msg.includes('load failed') ||
    msg.includes('the network connection was lost') ||
    msg.includes('cors') ||
    (err instanceof TypeError && !msg) // alguns browsers lançam TypeError sem msg
  );
}

export async function runOnlineOrToast<T>(action: () => Promise<T>): Promise<T> {
  if (isOffline()) {
    toast.error('Esta ação depende de internet. Não foi possível completar.');
    throw new Error('offline');
  }
  try {
    return await action();
  } catch (err) {
    if (isLikelyNetworkError(err)) {
      toast.error('Esta ação depende de internet. Não foi possível completar.');
    }
    throw err;
  }
}
